import { List } from 'immutable';
import { kycCompanyConstants } from '../constants';

export function kyc_companies(state = {}, action) {
  switch (action.type) {
    case kycCompanyConstants.KYC_COMPANY_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case kycCompanyConstants.KYC_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case kycCompanyConstants.KYC_COMPANY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case kycCompanyConstants.KYC_COMPANY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case kycCompanyConstants.KYC_COMPANY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case kycCompanyConstants.KYC_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case kycCompanyConstants.KYC_COMPANY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case kycCompanyConstants.KYC_COMPANY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const kycCompanyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (kycCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(kycCompanyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case kycCompanyConstants.KYC_COMPANY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case kycCompanyConstants.KYC_COMPANY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case kycCompanyConstants.KYC_COMPANY_DELETE_SUCCESS: {
      const { kycCompanyId } = action;

      if (!state.items) {
        return state;
      }

      const kycCompanyIndex = state.items.findIndex(val => val.id == kycCompanyId);

      if (kycCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(kycCompanyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case kycCompanyConstants.KYC_COMPANY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case kycCompanyConstants.KYC_COMPANY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
